//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import round from '~/mixins/round'
import ceil from '~/mixins/ceil'
import GTM from '~/utils/classes/Gtm'
import BoatReview from '~/components/Boats/card/boat-review.vue'
//import CountDwonOption from '~/components/Boats/countDownOption.vue'
import {SEARCH_REG_WHITELIST_ROUTER_QUERY} from "~/utils/search/search.constants";

export default {
  name: 'BoatCard',
  components: {
   // CountDwonOption,
    BoatReview
  },
  filters: {
    feetToMeters (value) {
      return (parseFloat(value) * 0.3048).toFixed(2)
    },
    removeBetweenBrackets (value) {
      return value.replace(/\([\s\S]*?\)/g, '')
    },
    fdate (value) {
      const st = value.split(' ')
      const dt = st[0].split('.')
      if (dt.length < 3) {
        return value
      }
      return dt[2] + '-' + dt[1] + '-' + dt[0] + ' ' + st[1]
    }
  },
  mixins: [round, ceil],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    searchTerms: {
      type: Object,
      default: () => {}
    },
    withDate: {
      type: Boolean,
      default: false
    },
    favoriteIconType: {
      type: String,
      default: 'default'
    },
    credits: {
      type: Number,
      default: 0
    },
    ifFavorites: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loadingBoat: false,
      stars: new Array(5),
      gtm: new GTM(this.$gtm),
      showPrebooked: false,
      hoverPremiumTip: true
    }
  },
  computed: {
    ...mapGetters({
      check: 'auth/check'
    }),
    ...mapState({
      breakpoint: state => state.breakpoint
    }),
    isDesktopOrTablet () {
          return this.breakpoint.isDesktopOrTablet
    },
    getOnline () {
      return this.searchTerms?.booking_option_id === 1
    },
    getPreBook () {
      return this.item?.underOption
    },
    getTerms () {
      const result = []
      if (this.item?.terms?.length) {
        return this.item.terms
      }
      return result
    },
    getDuration () {
      const raw = this.item.rentingOption
      const int = parseInt(this.item.rentingOption)
      if (!raw) {
        return this.searchTerms?.duration
      }
      let multiple = 1
      if (raw.includes('week')) {
        multiple = 7
      }
      if (raw.includes('month')) {
        multiple = 30
      }
      if (raw.includes('months')) {
        multiple = 30
      }
      return int * multiple + 1
    },
    imageAltText () {
      return `${this.item.boat_type}, ${this.item.name} (${this.item.year}) in ${this.item.city}, ${this.item.country}`
    },
    getDetailPageUrl () {
      const urlParams = {}
      if (this.searchTerms && this.searchTerms.start_date) {
        urlParams.start_date = this.searchTerms.start_date
      }

      if (this.searchTerms.duration) {
        urlParams.duration = this.searchTerms.duration
      }

      if (this.searchTerms.guests) {
        urlParams.guests = this.searchTerms.guests
      }

      if (this.$route?.query) {
        for (const [key, value] of Object.entries(this.$route?.query)) {
          if (SEARCH_REG_WHITELIST_ROUTER_QUERY.some(rx => rx.test(key))) {
            urlParams[key] = value
          }
        }
      }
      return urlParams
    },
    getDiscountPercentage () {
      const percentage = this?.item?.discounts?.percentage
      // ((this?.item?.discounts?.originalPrice - this?.item?.discounts?.newPrice) / this?.item?.discounts?.originalPrice) * 100
      return parseFloat(this.$options.filters.round(percentage, { fixed: 0 })) || 0
    },
    getPriceFrom () {
      return this?.item?.discounts?.price_from || 0
    },
    isPremium () {
      return !!parseInt(this.item?.premium_boat, 10)
    }
  },
  methods: {

    togglePrebooked () {
          if (!this.breakpoint.isDesktop) {
            this.showPrebooked = !this.showPrebooked
          }
        },
    setHoverPremium (value, id) {
      if (!this.$refs[`premium-tip-${id}`]) {
        return
      }
      if (value) {
        this.hoverPremiumTip = true
        this.$refs[`premium-tip-${id}`].show()
      } else {
        this.$nextTick(() => {
          this.hoverPremiumTip = false
        })
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.hoverPremiumTip = true
            })
          })
        })
      }
    },
    isProposalSearch () {
      return (
        (this.searchTerms.hasOwnProperty('requestId') &&
          this.searchTerms.requestId !== null) ||
        (this.searchTerms.hasOwnProperty('proposal') &&
          this.searchTerms.proposal !== null)
      )
    },
    loading () {
      this.loadingBoat = true
    },
    recordClick (loading = false) {
      if (loading) {
        this.loading()
      }

      if (
        process.client &&
        this.index &&
        window.hasOwnProperty('dataLayer')
      ) {
        this.gtm.selectItem({ ...this.item })
      }
    }
  }
}
